import { breakpoints, useMediaQuery } from '@coursera/cds-core';

const useMobile = () => {
  const isMobile = useMediaQuery(breakpoints.down('sm'));

  return { isMobile };
};

export default useMobile;
